import React from "react"

const CampaignInfoSection = () => (
  <section className="bg-night bg-circles text-white leading-normal px-content-mobile md:px-content">
    <p className="mx-auto max-w-paragraph pt-8 pb-16 md:text-lg">
      It’s no surprise that a generation who grew up on the internet has plenty
      of insights on how to make it better. These teens want you to know that
      social media affects their lives in very real ways, and it shouldn’t just
      be up to them to create safe online spaces. They’re challenging today’s
      biggest technology companies to thoughtfully improve their platforms for
      young people and the world at large. Together, we can all help technology
      become a force for good.
    </p>
  </section>
)

export default CampaignInfoSection
